import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useShop } from "../context/ShopContext";
import { inr } from "../lib/api";
import { optImg } from "../lib/assets";

export default function ProductCard({ product, index = 0 }) {
  const { addToCart, toggleWishlist, wishlist, setCartOpen } = useShop();
  const wished = wishlist.some((p) => p.id === product.id);
  const tag = product.tags?.includes("new") ? "NEW" : product.tags?.includes("bestseller") ? "BESTSELLER" : null;

  return (
    <div data-testid={`product-card-${product.slug}`} className="group">
      <div className="relative overflow-hidden bg-vv-elevated aspect-[3/4]">
        <Link to={`/product/${product.slug}`} data-testid={`product-link-${product.slug}`}>
          <img src={optImg(product.images?.[0], 700)} alt={product.name} loading={index > 3 ? "lazy" : "eager"} decoding="async"
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
          {product.images?.[1] && (
            <img src={optImg(product.images[1], 700)} alt="" loading="lazy" decoding="async" aria-hidden
              className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
          )}
        </Link>
        {tag && (
          <span data-testid={`product-tag-${product.slug}`}
            className={`absolute top-3 left-3 text-[9px] tracking-[0.25em] px-2.5 py-1 ${tag === "NEW" ? "bg-vv-forest text-vv-ivory" : "bg-vv-ivory text-vv-black"}`}>
            {tag}
          </span>
        )}
        <button data-testid={`wishlist-toggle-${product.slug}`} onClick={() => toggleWishlist(product)} aria-label="Wishlist"
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-vv-ivory/80 backdrop-blur-sm rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <Heart size={14} strokeWidth={1.5} className={wished ? "fill-vv-burgundy text-vv-burgundy" : "text-vv-black"} />
        </button>
        <div className="absolute bottom-0 inset-x-0 translate-y-full group-hover:translate-y-0 transition-transform duration-400 ease-out bg-vv-ivory/95 backdrop-blur-sm px-4 py-3 hidden md:block">
          <p className="text-[9px] uppercase tracking-[0.25em] text-vv-muted mb-2">Quick Add — Select Size</p>
          <div className="flex flex-wrap gap-1.5">
            {(product.sizes || []).map((s) => (
              <button key={s} data-testid={`quick-add-${product.slug}-${s}`}
                onClick={() => { addToCart(product, s, product.colors?.[0]?.name || ""); }}
                className="text-[10px] tracking-wider border border-vv-black/20 px-2.5 py-1 hover:bg-vv-black hover:text-vv-ivory transition-colors">
                {s}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="pt-4 flex items-start justify-between gap-3">
        <div>
          <Link to={`/product/${product.slug}`} className="text-sm font-medium leading-snug hover:opacity-70 transition-opacity">
            {product.name}
          </Link>
          <div className="flex gap-1.5 mt-2">
            {(product.colors || []).map((c) => (
              <span key={c.name} title={c.name} className="w-3 h-3 rounded-full border border-vv-black/20" style={{ background: c.hex }} />
            ))}
          </div>
        </div>
        <p data-testid={`product-price-${product.slug}`} className="text-sm font-medium whitespace-nowrap">
          {product.compare_at > product.price && (
            <span className="text-xs text-vv-stone line-through mr-1.5 font-normal">{inr(product.compare_at)}</span>
          )}
          {inr(product.price)}
        </p>
      </div>
    </div>
  );
}
